var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.contentType == 1 || _vm.contentType == 2
        ? _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "HeartIcon", size: "19" },
                      }),
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "120px" },
                        },
                        [_vm._v(" 컨텐츠 유형 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.resetInterestContent()
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "Trash2Icon" },
                          }),
                          _c("span", [_vm._v("초기화")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "컨텐츠 유형",
                            "label-for": "liveinfo-interest-content",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "liveinfo-interest-content",
                              value: _vm.liveinfo.interestContentTitles || "",
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start mt-50",
                      attrs: { cols: "6", md: "6" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.showInterestContentSelect = true
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "SearchIcon" },
                          }),
                          _c("span", [_vm._v("유형 선택")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "validation-observer",
        { ref: "liveinfoFormRules" },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "2" },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "CalendarIcon", size: "19" },
                      }),
                      _c("h4", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(" 게시기간 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "게시기간(Fr)",
                            "label-for": "liveinfo-start-date",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "게시기간(Fr)",
                              rules: {
                                required: true,
                                before: _vm.liveinfo.endDate,
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "b-form-datepicker",
                                      _vm._b(
                                        {
                                          attrs: {
                                            id: "liveinfo-start-date",
                                            placeholder: "게시기간(Fr)",
                                            state:
                                              errors.length > 0 ? false : null,
                                          },
                                          model: {
                                            value: _vm.liveinfo.startDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.liveinfo,
                                                "startDate",
                                                $$v
                                              )
                                            },
                                            expression: "liveinfo.startDate",
                                          },
                                        },
                                        "b-form-datepicker",
                                        _vm.contentType === 3
                                          ? {
                                              "date-disabled-fn": function (
                                                ymd
                                              ) {
                                                return _vm.dateDisabled(
                                                  ymd,
                                                  null
                                                )
                                              },
                                              readonly:
                                                _vm.liveinfoId !== null &&
                                                _vm.liveinfo.startDate !==
                                                  null &&
                                                _vm.dateDisabled(
                                                  _vm.liveinfo.startDate,
                                                  null,
                                                  true
                                                ),
                                              style: _vm.getInputGroupStyle(
                                                "",
                                                _vm.liveinfoId !== null &&
                                                  _vm.liveinfo.startDate !==
                                                    null &&
                                                  _vm.dateDisabled(
                                                    _vm.liveinfo.startDate,
                                                    null,
                                                    true
                                                  )
                                              ),
                                              disabled:
                                                _vm.liveinfoId !== null &&
                                                _vm.liveinfo.startDate !==
                                                  null &&
                                                _vm.dateDisabled(
                                                  _vm.liveinfo.startDate,
                                                  null,
                                                  true
                                                ),
                                            }
                                          : {},
                                        false
                                      )
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "게시기간(To)",
                            "label-for": "liveinfo-end-date",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "게시기간(To)",
                              rules: {
                                required: true,
                                after: _vm.liveinfo.startDate,
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "b-form-datepicker",
                                      _vm._b(
                                        {
                                          attrs: {
                                            id: "liveinfo-end-date",
                                            placeholder: "게시기간(To)",
                                            state:
                                              errors.length > 0 ? false : null,
                                          },
                                          model: {
                                            value: _vm.liveinfo.endDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.liveinfo,
                                                "endDate",
                                                $$v
                                              )
                                            },
                                            expression: "liveinfo.endDate",
                                          },
                                        },
                                        "b-form-datepicker",
                                        _vm.contentType === 3
                                          ? {
                                              "date-disabled-fn": function (
                                                ymd
                                              ) {
                                                return _vm.dateDisabled(
                                                  ymd,
                                                  _vm.originalLiveInfoEndDate
                                                )
                                              },
                                              readonly:
                                                _vm.liveinfoId !== null &&
                                                _vm.liveinfo.endDate !== null &&
                                                _vm.dateDisabled(
                                                  _vm.originalLiveInfoEndDate,
                                                  null,
                                                  false
                                                ),
                                              style: _vm.getInputGroupStyle(
                                                "",
                                                _vm.liveinfoId !== null &&
                                                  _vm.liveinfo.endDate !==
                                                    null &&
                                                  _vm.dateDisabled(
                                                    _vm.originalLiveInfoEndDate,
                                                    null,
                                                    false
                                                  )
                                              ),
                                              disabled:
                                                _vm.liveinfoId !== null &&
                                                _vm.liveinfo.endDate !== null &&
                                                _vm.dateDisabled(
                                                  _vm.originalLiveInfoEndDate,
                                                  null,
                                                  false
                                                ),
                                            }
                                          : {},
                                        false
                                      )
                                    ),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-card",
            [
              _c(
                "validation-observer",
                { ref: "condSetTypeFormRules" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-start",
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "UserCheckIcon", size: "19" },
                          }),
                          _c("h4", { staticClass: "mb-0 ml-50" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getCodeLabel(
                                    "contentName",
                                    _vm.contentType
                                  )
                                ) +
                                " 노출 조건 "
                            ),
                          ]),
                          _c("ViewListBadge", {
                            attrs: {
                              "content-type": _vm.contentType,
                              "condition-type": 10,
                              "show-guide": true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", { attrs: { for: "cond-set-type" } }, [
                                _vm._v("노출 대상"),
                              ]),
                              _c(
                                "b-form-radio-group",
                                {
                                  attrs: {
                                    name: "condSetType",
                                    disabled: _vm.isStarted,
                                  },
                                  model: {
                                    value: _vm.liveinfo.condSetType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.liveinfo, "condSetType", $$v)
                                    },
                                    expression: "liveinfo.condSetType",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    {
                                      staticClass: "custom-control-primary",
                                      attrs: { value: "11" },
                                      on: { change: _vm.changeCondSetType },
                                    },
                                    [_vm._v(" 진료과/지역별 사용자 ")]
                                  ),
                                  _vm.contentType != 8
                                    ? _c(
                                        "b-form-radio",
                                        {
                                          staticClass:
                                            "custom-control-secondary",
                                          attrs: { value: "21" },
                                          on: { change: _vm.changeCondSetType },
                                        },
                                        [_vm._v(" 타겟그룹 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.contentType == 1
                        ? _c(
                            "b-col",
                            [
                              _vm.contentType == 1
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              "세팅 정보로 닥터인포에 노출하기"
                                            ),
                                          ]),
                                          _c("ViewListBadge", {
                                            attrs: {
                                              "content-type": _vm.contentType,
                                              "condition-type": 901,
                                              "show-guide": true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            [
                                              _c(
                                                "b-form-radio-group",
                                                {
                                                  attrs: {
                                                    disabled: _vm.isStarted,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.liveinfo
                                                        .isCondDeptDrInfo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.liveinfo,
                                                        "isCondDeptDrInfo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "liveinfo.isCondDeptDrInfo",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-form-radio",
                                                    {
                                                      staticClass:
                                                        "custom-control-primary",
                                                      attrs: { value: "true" },
                                                    },
                                                    [_vm._v(" 사용 ")]
                                                  ),
                                                  _c(
                                                    "b-form-radio",
                                                    {
                                                      staticClass:
                                                        "custom-control-secondary",
                                                      attrs: { value: "false" },
                                                    },
                                                    [_vm._v(" 사용안함 ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.liveinfo.condSetType == 11
                    ? _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "10" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "liveinfo-cond-dept" } },
                                    [_vm._v("진료과")]
                                  ),
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "진료과",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "liveinfo-cond-dept",
                                                  readonly: "",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.liveinfo.condDeptNames,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.liveinfo,
                                                      "condDeptNames",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "liveinfo.condDeptNames",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3060256983
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-50", attrs: { cols: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-0 mt-md-2",
                                  attrs: { variant: "outline-primary" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.showMediDeptSelect = true
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "PlusSquareIcon" },
                                  }),
                                  _c("span", [_vm._v("진료과 선택")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.liveinfo.condSetType == 11
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "10" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "liveinfo-cond-region" } },
                                    [_vm._v("지역")]
                                  ),
                                  _c("validation-provider", {
                                    attrs: { name: "지역", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "liveinfo-cond-region",
                                                  readonly: "",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.liveinfo
                                                      .condRegionNames,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.liveinfo,
                                                      "condRegionNames",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "liveinfo.condRegionNames",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2254933591
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-50", attrs: { cols: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-0 mt-md-2",
                                  attrs: { variant: "outline-primary" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.showRegionSelect = true
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "PlusSquareIcon" },
                                  }),
                                  _c("span", [_vm._v("지역 선택")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.liveinfo.condSetType == 21
                    ? _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "10", md: "5" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { disabled: _vm.isStarted } },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "liveinfo-cond-targetgroup",
                                      },
                                    },
                                    [_vm._v("타겟그룹")]
                                  ),
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "타겟그룹",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            var validate = ref.validate
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "liveinfo-cond-targetgroup",
                                                  value: _vm.liveinfo
                                                    .targetGroupId
                                                    ? "[" +
                                                      _vm.liveinfo
                                                        .targetGroupId +
                                                      "] " +
                                                      _vm.liveinfo
                                                        .targetGroupTitle
                                                    : "",
                                                  readonly: "",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                on: { input: validate },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2299001458
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-50",
                              attrs: { cols: "12", md: "4" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-0 mt-md-2",
                                  attrs: {
                                    variant: "outline-primary",
                                    disabled: _vm.isStarted,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.showTargetGroupSelect = true
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "SearchIcon" },
                                  }),
                                  _c("span", [_vm._v("타겟그룹 선택")]),
                                ],
                                1
                              ),
                              _vm.liveinfo.targetGroupId
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "ml-1 mt-0 mt-md-2",
                                      attrs: {
                                        variant: "outline-danger",
                                        disabled: _vm.isStarted,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.liveinfo.targetGroupId = null
                                          _vm.liveinfo.targetGroupTitle = null
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "Trash2Icon" },
                                      }),
                                      _c("span", [_vm._v("타겟그룹 제거")]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.contentType != 2 && _vm.contentType != 8
        ? _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "GridIcon", size: "19" },
                      }),
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "150px" },
                        },
                        [_vm._v(" 메인 노출 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          staticStyle: { "min-width": "120px" },
                          attrs: { switch: "", inline: "" },
                          model: {
                            value: _vm.liveinfo.isMainView,
                            callback: function ($$v) {
                              _vm.$set(_vm.liveinfo, "isMainView", $$v)
                            },
                            expression: "liveinfo.isMainView",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.liveinfo.isMainView ? "사용" : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "validation-observer",
                { ref: "liveinfoMainRules" },
                [
                  _c(
                    "b-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.liveinfo.isMainView,
                          expression: "liveinfo.isMainView",
                        },
                      ],
                      staticClass: "mt-1",
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "게시기간(Fr)",
                                "label-for": "liveinfo-main-start-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "게시기간(Fr)",
                                  rules: {
                                    required: true,
                                    before: _vm.liveinfo.mainEndDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-main-start-date",
                                              placeholder: "게시기간(Fr)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.mainStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "mainStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.mainStartDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "메인 노출 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  768274914
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "게시기간(To)",
                                "label-for": "liveinfo-main-end-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "게시기간(To)",
                                  rules: {
                                    required: true,
                                    after: _vm.liveinfo.mainStartDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-main-end-date",
                                              placeholder: "게시기간(To)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.mainEndDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "mainEndDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.mainEndDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "메인 노출 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2172363405
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.liveinfo.isMainView,
                          expression: "liveinfo.isMainView",
                        },
                      ],
                      staticClass: "mt-1",
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label:
                                  "상단 고정 (메인 노출 게시 기간 종료일을 오늘 또는 이후 날짜로 설정해야 사용할 수 있습니다.)",
                                "label-for": "liveinfo-is-main-top-fix",
                              },
                            },
                            [
                              _c(
                                "b-form-radio-group",
                                {
                                  attrs: {
                                    disabled: _vm.liveinfo.mainEndDate
                                      ? _vm.liveinfo.mainEndDate <
                                        _vm.dayjs().format("YYYY-MM-DD")
                                      : true,
                                  },
                                  model: {
                                    value: _vm.liveinfo.isMainTopFix,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.liveinfo,
                                        "isMainTopFix",
                                        $$v
                                      )
                                    },
                                    expression: "liveinfo.isMainTopFix",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    {
                                      staticClass: "custom-control-primary",
                                      attrs: { value: true },
                                    },
                                    [_vm._v(" 사용 ")]
                                  ),
                                  _c(
                                    "b-form-radio",
                                    {
                                      staticClass: "custom-control-secondary",
                                      attrs: { value: false },
                                    },
                                    [_vm._v(" 사용안함 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "outline-primary",
                                disabled: !_vm.liveinfo.isMainTopFix,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.isMainTopFixed
                                    ? (_vm.showMainTopFixManage = true)
                                    : (_vm.showMainTopFixManageGuide = true)
                                },
                              },
                            },
                            [_c("span", [_vm._v("우선순위 설정")])]
                          ),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "12", md: "12" } }, [
                        _vm.showMainTopFixManageGuide
                          ? _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                " 상단 고정을 ‘사용’으로 선택하고 컨텐츠를 저장한 후에 우선순위 설정이 가능합니다. "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contentType == 1,
              expression: "contentType == 1",
            },
          ],
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "RefreshCwIcon", size: "19" },
                  }),
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "150px" },
                    },
                    [_vm._v(" 라이브 DI ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: { switch: "", inline: "" },
                      model: {
                        value: _vm.liveinfo.isLiveDi,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveinfo, "isLiveDi", $$v)
                        },
                        expression: "liveinfo.isLiveDi",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.liveinfo.isLiveDi ? "사용" : "사용안함") +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "validation-observer",
            { ref: "liveinfoIsLiveDiRules" },
            [
              _vm.liveinfo.isLiveDi
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "노출 메시지",
                                "label-for": "liveinfo-livedi-title",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "노출 메시지",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "liveinfo-livedi-title",
                                              placeholder: "입력하세요",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.liveDiTitle,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "liveDiTitle",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.liveDiTitle",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4129831602
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.liveinfo.isLiveDi
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "label",
                                { attrs: { for: "liveinfo-livedi-title" } },
                                [_vm._v("노출 기간")]
                              ),
                              _c(
                                "label",
                                { staticClass: "ml-50 text-secondary" },
                                [_vm._v(" (게시기간 : ")]
                              ),
                              _c(
                                "label",
                                { staticClass: "ml-50 text-primary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      "" +
                                        (!_vm.liveinfo.startDate
                                          ? "미지정"
                                          : _vm.liveinfo.startDate)
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "label",
                                { staticClass: "ml-50 text-secondary" },
                                [_vm._v("~")]
                              ),
                              _c(
                                "label",
                                { staticClass: "ml-50 text-primary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      " " +
                                        (!_vm.liveinfo.endDate
                                          ? "미지정"
                                          : _vm.liveinfo.endDate)
                                    )
                                  ),
                                ]
                              ),
                              _c("label", { staticClass: "text-secondary" }, [
                                _vm._v(") "),
                              ]),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "3" } },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "노출기간(Fr)",
                                          rules: {
                                            required: true,
                                            dateBetween: [
                                              _vm.liveinfo.startDate,
                                              _vm.liveinfo.endDate,
                                            ],
                                            dateBefore:
                                              _vm.liveinfo.liveDiEndDate,
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                var failedRules =
                                                  ref.failedRules
                                                return [
                                                  _c("b-form-datepicker", {
                                                    style:
                                                      _vm.getInputGroupStyle(
                                                        "",
                                                        _vm.liveinfo
                                                          .liveDiStartDate !==
                                                          null &&
                                                          _vm.dateDisabled(
                                                            _vm.liveinfo
                                                              .liveDiStartDate,
                                                            null
                                                          )
                                                      ),
                                                    attrs: {
                                                      id: "liveinfo-livedi-start-date",
                                                      size: "md",
                                                      placeholder:
                                                        "노출기간(Fr)",
                                                      readonly:
                                                        _vm.liveinfo
                                                          .liveDiStartDate !==
                                                          null &&
                                                        _vm.dateDisabled(
                                                          _vm.liveinfo
                                                            .liveDiStartDate,
                                                          null
                                                        ),
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                      "date-disabled-fn":
                                                        function (ymd) {
                                                          return _vm.dateDisabled(
                                                            ymd,
                                                            null
                                                          )
                                                        },
                                                      disabled:
                                                        _vm.liveinfo
                                                          .liveDiStartDate !==
                                                          null &&
                                                        _vm.dateDisabled(
                                                          _vm.liveinfo
                                                            .liveDiStartDate,
                                                          null
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.liveinfo
                                                          .liveDiStartDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.liveinfo,
                                                          "liveDiStartDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "liveinfo.liveDiStartDate",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            failedRules.hasOwnProperty(
                                                              "required"
                                                            )
                                                              ? "필수 입력값입니다."
                                                              : failedRules.hasOwnProperty(
                                                                  "dateBetween"
                                                                )
                                                              ? "게시기간 내로 입력해주세요."
                                                              : failedRules.hasOwnProperty(
                                                                  "dateBefore"
                                                                )
                                                              ? "종료일보다 늦을 수 없습니다."
                                                              : errors[0]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1832540278
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" ~ "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "3" } },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "노출기간(To)",
                                          rules: {
                                            required: true,
                                            dateBetween: [
                                              _vm.liveinfo.startDate,
                                              _vm.liveinfo.endDate,
                                            ],
                                            dateAfter:
                                              _vm.liveinfo.liveDiStartDate >
                                              _vm.originalLiveDiEndDate
                                                ? _vm.liveinfo.liveDiStartDate
                                                : _vm.originalLiveDiEndDate,
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                var failedRules =
                                                  ref.failedRules
                                                return [
                                                  _c("b-form-datepicker", {
                                                    style:
                                                      _vm.getInputGroupStyle(
                                                        "",
                                                        _vm.liveinfo
                                                          .liveDiEndDate !==
                                                          null &&
                                                          _vm.dateDisabled(
                                                            _vm.liveDiEndDateNextDay,
                                                            null
                                                          )
                                                      ),
                                                    attrs: {
                                                      id: "liveinfo-livedi-end-date",
                                                      size: "md",
                                                      placeholder:
                                                        "노출기간(To)",
                                                      readonly:
                                                        _vm.liveinfo
                                                          .liveDiEndDate !==
                                                          null &&
                                                        _vm.dateDisabled(
                                                          _vm.liveDiEndDateNextDay,
                                                          null
                                                        ),
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                      "date-disabled-fn":
                                                        function (ymd) {
                                                          return _vm.dateDisabled(
                                                            ymd,
                                                            _vm.originalLiveDiEndDate
                                                          )
                                                        },
                                                      disabled:
                                                        _vm.liveinfo
                                                          .liveDiEndDate !==
                                                          null &&
                                                        _vm.dateDisabled(
                                                          _vm.liveDiEndDateNextDay,
                                                          null
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.liveinfo
                                                          .liveDiEndDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.liveinfo,
                                                          "liveDiEndDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "liveinfo.liveDiEndDate",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            failedRules.hasOwnProperty(
                                                              "required"
                                                            )
                                                              ? "필수 입력값입니다."
                                                              : failedRules.hasOwnProperty(
                                                                  "dateBetween"
                                                                )
                                                              ? "게시기간 내로 입력해주세요."
                                                              : failedRules.hasOwnProperty(
                                                                  "dateAfter"
                                                                )
                                                              ? "시작일 또는 기설정 종료일보다 빠를 수 없습니다."
                                                              : errors[0]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          995326561
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.liveinfo.isLiveDi
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "라이브DI 교차조건",
                                "label-for": "liveinfo-is-livedi-or",
                              },
                            },
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "liveinfo-is-livedi-or",
                                  options: _vm.constCodes.conditionOr,
                                  "value-field": "code",
                                  "text-field": "label",
                                },
                                model: {
                                  value: _vm.liveinfo.isLiveDiOr,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.liveinfo, "isLiveDiOr", $$v)
                                  },
                                  expression: "liveinfo.isLiveDiOr",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            "※ 같은 칸 안의 코드는 쉼표(,)로 구분(OR), 칸을 추가하면 칸 사이는 AND 로 비교됩니다."
                          ),
                        ]),
                      ]),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "청구코드",
                              rules: {
                                requiredIf:
                                  !_vm.liveDiCondDiseaseCodesModel &&
                                  !_vm.liveDiCondLabCodesModel,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "청구코드 (같은 칸 = OR / 칸 추가 = AND)",
                                            "label-for":
                                              "liveinfo-livedi-drug-codes",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "d-none",
                                            model: {
                                              value:
                                                _vm.liveDiCondDrugCodesModel,
                                              callback: function ($$v) {
                                                _vm.liveDiCondDrugCodesModel =
                                                  $$v
                                              },
                                              expression:
                                                "liveDiCondDrugCodesModel",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.liveinfo
                                              .liveDiCondDrugCodeGroups,
                                            function (group, gIdx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "livedi-drug-" + gIdx,
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  class: {
                                                    "mt-25": gIdx !== 0,
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "코드를 입력하세요 (쉼표 구분 시 OR)",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value: group.code,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          group,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "group.code",
                                                    },
                                                  }),
                                                  _vm.liveinfo
                                                    .liveDiCondDrugCodeGroups
                                                    .length > 1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeCodeGroup(
                                                                _vm.liveinfo
                                                                  .liveDiCondDrugCodeGroups,
                                                                gIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "XIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  gIdx ===
                                                  _vm.liveinfo
                                                    .liveDiCondDrugCodeGroups
                                                    .length -
                                                    1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addCodeGroup(
                                                                _vm.liveinfo
                                                                  .liveDiCondDrugCodeGroups
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "PlusIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    errors.length > 0
                                                      ? "라이브 DI 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다."
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3754646866
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "질병코드",
                              rules: {
                                requiredIf:
                                  !_vm.liveDiCondDrugCodesModel &&
                                  !_vm.liveDiCondLabCodesModel,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "질병코드 (같은 칸 = OR / 칸 추가 = AND)",
                                            "label-for":
                                              "liveinfo-livedi-disease-codes",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "d-none",
                                            model: {
                                              value:
                                                _vm.liveDiCondDiseaseCodesModel,
                                              callback: function ($$v) {
                                                _vm.liveDiCondDiseaseCodesModel =
                                                  $$v
                                              },
                                              expression:
                                                "liveDiCondDiseaseCodesModel",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.liveinfo
                                              .liveDiCondDiseaseCodeGroups,
                                            function (group, gIdx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "livedi-disease-" + gIdx,
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  class: {
                                                    "mt-25": gIdx !== 0,
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "코드를 입력하세요 (쉼표 구분 시 OR)",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value: group.code,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          group,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "group.code",
                                                    },
                                                  }),
                                                  _vm.liveinfo
                                                    .liveDiCondDiseaseCodeGroups
                                                    .length > 1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeCodeGroup(
                                                                _vm.liveinfo
                                                                  .liveDiCondDiseaseCodeGroups,
                                                                gIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "XIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  gIdx ===
                                                  _vm.liveinfo
                                                    .liveDiCondDiseaseCodeGroups
                                                    .length -
                                                    1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addCodeGroup(
                                                                _vm.liveinfo
                                                                  .liveDiCondDiseaseCodeGroups
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "PlusIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    errors.length > 0
                                                      ? "라이브 DI 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다."
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4249126602
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "검사코드",
                              rules: {
                                requiredIf:
                                  !_vm.liveDiCondDrugCodesModel &&
                                  !_vm.liveDiCondDiseaseCodesModel,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "검사코드 (같은 칸 = OR / 칸 추가 = AND ※ 검사는 원코드 5자리로 입력. e.g. 'D2280000'[X] 'D2280'[O])",
                                            "label-for":
                                              "liveinfo-livedi-lab-codes",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "d-none",
                                            model: {
                                              value:
                                                _vm.liveDiCondLabCodesModel,
                                              callback: function ($$v) {
                                                _vm.liveDiCondLabCodesModel =
                                                  $$v
                                              },
                                              expression:
                                                "liveDiCondLabCodesModel",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.liveinfo
                                              .liveDiCondLabCodeGroups,
                                            function (group, gIdx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "livedi-lab-" + gIdx,
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  class: {
                                                    "mt-25": gIdx !== 0,
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "코드를 입력하세요 (쉼표 구분 시 OR)",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value: group.code,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          group,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "group.code",
                                                    },
                                                  }),
                                                  _vm.liveinfo
                                                    .liveDiCondLabCodeGroups
                                                    .length > 1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeCodeGroup(
                                                                _vm.liveinfo
                                                                  .liveDiCondLabCodeGroups,
                                                                gIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "XIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  gIdx ===
                                                  _vm.liveinfo
                                                    .liveDiCondLabCodeGroups
                                                    .length -
                                                    1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addCodeGroup(
                                                                _vm.liveinfo
                                                                  .liveDiCondLabCodeGroups
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "PlusIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    errors.length > 0
                                                      ? "라이브 DI 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다."
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3886553914
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "BellIcon", size: "19" },
                  }),
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "150px" },
                    },
                    [_vm._v(" 처방 팝업 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: { switch: "", inline: "" },
                      model: {
                        value: _vm.liveinfo.isInfoPopUp,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveinfo, "isInfoPopUp", $$v)
                        },
                        expression: "liveinfo.isInfoPopUp",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.liveinfo.isInfoPopUp ? "사용" : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "validation-observer",
            { ref: "liveinfoIsInfoPopRules" },
            [
              _vm.liveinfo.isInfoPopUp
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림기간(Fr)",
                                "label-for": "liveinfo-ipu-start-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림기간(Fr)",
                                  rules: {
                                    required: true,
                                    before: _vm.liveinfo.ipuEndDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-ipu-start-date",
                                              placeholder: "알림기간(Fr)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.spuOneTimeChange()
                                              },
                                            },
                                            model: {
                                              value: _vm.liveinfo.ipuStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "ipuStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.ipuStartDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "처방 팝업 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3185305513
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림기간(To)",
                                "label-for": "liveinfo-ipu-end-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림기간(To)",
                                  rules: {
                                    required: true,
                                    after: _vm.liveinfo.ipuStartDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-ipu-end-date",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              placeholder: "알림기간(To))",
                                            },
                                            model: {
                                              value: _vm.liveinfo.ipuEndDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "ipuEndDate",
                                                  $$v
                                                )
                                              },
                                              expression: "liveinfo.ipuEndDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "처방 팝업 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  182840837
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "12", md: "6" } }),
                      _c(
                        "b-col",
                        { attrs: { cols: "6", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "처방팝업 알림 시간",
                                "label-for": "liveinfo-is-immediate",
                              },
                            },
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "liveinfo-is-immediate",
                                  options: _vm.constCodes.immediateOr,
                                  "value-field": "code",
                                  "text-field": "label",
                                },
                                model: {
                                  value: _vm.liveinfo.isImmediate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.liveinfo, "isImmediate", $$v)
                                  },
                                  expression: "liveinfo.isImmediate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "6", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림횟수",
                                "label-for": "liveinfo-ipu-pop-count",
                              },
                            },
                            [
                              _c("b-form-spinbutton", {
                                attrs: {
                                  id: "liveinfo-ipu-pop-count",
                                  min: "1",
                                  max: "10",
                                  inline: "",
                                },
                                model: {
                                  value: _vm.liveinfo.ipuPopCount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.liveinfo, "ipuPopCount", $$v)
                                  },
                                  expression: "liveinfo.ipuPopCount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "6", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림 유지시간",
                                "label-for": "liveinfo-ipu-delay-sec",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림 유지시간",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("v-select", {
                                            attrs: {
                                              id: "liveinfo-ipu-delay-sec",
                                              options:
                                                _vm.constCodes.selectTimes,
                                              reduce: function (option) {
                                                return option.code
                                              },
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.ipuDelaySec,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "ipuDelaySec",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.ipuDelaySec",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2945046949
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "6", md: "3" } }),
                      !_vm.liveinfo.isImmediate
                        ? _c(
                            "div",
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _c("label", [_vm._v("알림 시간 선택")]),
                              ]),
                              _vm._l(
                                _vm.liveinfo.schedules,
                                function (sched, idx) {
                                  return _c(
                                    "b-col",
                                    {
                                      key: sched.id,
                                      staticClass:
                                        "d-flex align-items-center justify-content-start",
                                      class: { "mt-25": idx !== 0 },
                                      attrs: {
                                        id: "schedules" + sched.id,
                                        cols: "12",
                                      },
                                    },
                                    [
                                      sched.popUpType === 1
                                        ? [
                                            _c("validation-provider", {
                                              attrs: {
                                                name: "알림 시간 선택",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("v-date-picker", {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            type: "time",
                                                            format: "HH:mm",
                                                            "value-type":
                                                              "format",
                                                            placeholder:
                                                              "HH:mm",
                                                            "time-picker-options":
                                                              {
                                                                start: "08:00",
                                                                step: "00:05",
                                                                end: "20:00",
                                                              },
                                                          },
                                                          model: {
                                                            value:
                                                              sched.noticeTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                sched,
                                                                "noticeTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "sched.noticeTime",
                                                          },
                                                        }),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            idx !==
                                            _vm.getSchedIdxFirstOrLast(1, true)
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      variant: "outline-danger",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.liveinfo.schedules.splice(
                                                          idx,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      staticClass: "mr-25",
                                                      attrs: { icon: "XIcon" },
                                                    }),
                                                    _c("span", [
                                                      _vm._v("삭제"),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            idx ===
                                            _vm.getSchedIdxFirstOrLast(1, false)
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant:
                                                        "outline-primary",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.liveinfo.schedules.push(
                                                          {
                                                            noticeTime: null,
                                                            popUpType: 1,
                                                          }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      staticClass: "mr-25",
                                                      attrs: {
                                                        icon: "PlusIcon",
                                                      },
                                                    }),
                                                    _c("span", [
                                                      _vm._v("추가"),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "팝업 교차조건",
                                "label-for": "liveinfo-is-info-popup-or",
                              },
                            },
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "liveinfo-is-info-popup-or",
                                  options: _vm.constCodes.conditionOr,
                                  "value-field": "code",
                                  "text-field": "label",
                                },
                                model: {
                                  value: _vm.liveinfo.isInfoPopUpOr,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.liveinfo, "isInfoPopUpOr", $$v)
                                  },
                                  expression: "liveinfo.isInfoPopUpOr",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("label", [_vm._v("환자연령")]),
                                  _c("ViewListBadge", {
                                    attrs: {
                                      "content-type": _vm.contentType,
                                      "condition-type": 3,
                                      "show-guide": true,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-start",
                                  attrs: { cols: "12", lg: "6" },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "시작나이",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                on: {
                                                  keyup: _vm.restrictToNumbers,
                                                },
                                                model: {
                                                  value: _vm.liveinfo.minAge,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.liveinfo,
                                                      "minAge",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "liveinfo.minAge",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3496902910
                                    ),
                                  }),
                                  _c("label", { staticClass: "ml-50 mr-50" }, [
                                    _vm._v("~"),
                                  ]),
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "끝나이",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                on: {
                                                  keyup: _vm.restrictToNumbers,
                                                },
                                                model: {
                                                  value: _vm.liveinfo.maxAge,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.liveinfo,
                                                      "maxAge",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "liveinfo.maxAge",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2850216416
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            "※ 같은 칸 안의 코드는 쉼표(,)로 구분(OR), 칸을 추가하면 칸 사이는 AND 로 비교됩니다."
                          ),
                        ]),
                      ]),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "청구코드",
                              rules: {
                                requiredIf:
                                  !_vm.condDiseaseCodesModel &&
                                  !_vm.condLabCodesModel,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "청구코드 (같은 칸 = OR / 칸 추가 = AND)",
                                            "label-for": "liveinfo-drug-codes",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "d-none",
                                            model: {
                                              value: _vm.condDrugCodesModel,
                                              callback: function ($$v) {
                                                _vm.condDrugCodesModel = $$v
                                              },
                                              expression: "condDrugCodesModel",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.liveinfo.condDrugCodeGroups,
                                            function (group, gIdx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "drug-" + gIdx,
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  class: {
                                                    "mt-25": gIdx !== 0,
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "코드를 입력하세요 (쉼표 구분 시 OR)",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value: group.code,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          group,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "group.code",
                                                    },
                                                  }),
                                                  _vm.liveinfo
                                                    .condDrugCodeGroups.length >
                                                  1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeCodeGroup(
                                                                _vm.liveinfo
                                                                  .condDrugCodeGroups,
                                                                gIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "XIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  gIdx ===
                                                  _vm.liveinfo
                                                    .condDrugCodeGroups.length -
                                                    1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addCodeGroup(
                                                                _vm.liveinfo
                                                                  .condDrugCodeGroups
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "PlusIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    errors.length > 0
                                                      ? "처방팝업 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다."
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              25350354
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "질병코드",
                              rules: {
                                requiredIf:
                                  !_vm.condDrugCodesModel &&
                                  !_vm.condLabCodesModel,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "질병코드 (같은 칸 = OR / 칸 추가 = AND)",
                                            "label-for":
                                              "liveinfo-disease-codes",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "d-none",
                                            model: {
                                              value: _vm.condDiseaseCodesModel,
                                              callback: function ($$v) {
                                                _vm.condDiseaseCodesModel = $$v
                                              },
                                              expression:
                                                "condDiseaseCodesModel",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.liveinfo.condDiseaseCodeGroups,
                                            function (group, gIdx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "disease-" + gIdx,
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  class: {
                                                    "mt-25": gIdx !== 0,
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "코드를 입력하세요 (쉼표 구분 시 OR)",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value: group.code,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          group,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "group.code",
                                                    },
                                                  }),
                                                  _vm.liveinfo
                                                    .condDiseaseCodeGroups
                                                    .length > 1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeCodeGroup(
                                                                _vm.liveinfo
                                                                  .condDiseaseCodeGroups,
                                                                gIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "XIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  gIdx ===
                                                  _vm.liveinfo
                                                    .condDiseaseCodeGroups
                                                    .length -
                                                    1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addCodeGroup(
                                                                _vm.liveinfo
                                                                  .condDiseaseCodeGroups
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "PlusIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    errors.length > 0
                                                      ? "처방팝업 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다."
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1977105098
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "검사코드",
                              rules: {
                                requiredIf:
                                  !_vm.condDrugCodesModel &&
                                  !_vm.condDiseaseCodesModel,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label:
                                              "검사코드 (같은 칸 = OR / 칸 추가 = AND) (※ 검사는 원코드 5자리로 입력. e.g. 'D2280000'[X] 'D2280'[O])",
                                            "label-for": "liveinfo-lab-codes",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "d-none",
                                            model: {
                                              value: _vm.condLabCodesModel,
                                              callback: function ($$v) {
                                                _vm.condLabCodesModel = $$v
                                              },
                                              expression: "condLabCodesModel",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.liveinfo.condLabCodeGroups,
                                            function (group, gIdx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: "lab-" + gIdx,
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  class: {
                                                    "mt-25": gIdx !== 0,
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "코드를 입력하세요 (쉼표 구분 시 OR)",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value: group.code,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          group,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "group.code",
                                                    },
                                                  }),
                                                  _vm.liveinfo.condLabCodeGroups
                                                    .length > 1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-danger",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeCodeGroup(
                                                                _vm.liveinfo
                                                                  .condLabCodeGroups,
                                                                gIdx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "XIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  gIdx ===
                                                  _vm.liveinfo.condLabCodeGroups
                                                    .length -
                                                    1
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant:
                                                              "outline-primary",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.addCodeGroup(
                                                                _vm.liveinfo
                                                                  .condLabCodeGroups
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            attrs: {
                                                              icon: "PlusIcon",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    errors.length > 0
                                                      ? "처방팝업 사용시, 조건은 한가지 이상 반드시 입력되어야 합니다."
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3037676955
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label:
                                  "알림창 내용 (※ 처방팝업과 스케줄팝업 문구는 반드시 다르게 설정하여 주세요.)",
                                "label-for": "liveinfo-ipu-content",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림창 내용",
                                  rules: "required|popupContent",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("tinymce-editor", {
                                            attrs: { "is-table": true },
                                            model: {
                                              value: _vm.liveinfo.ipuContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "ipuContent",
                                                  $$v
                                                )
                                              },
                                              expression: "liveinfo.ipuContent",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  468789798
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contentType != 8,
              expression: "contentType != 8",
            },
          ],
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "ClockIcon", size: "19" },
                  }),
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "150px" },
                    },
                    [_vm._v(" 스케줄 팝업 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: { switch: "", inline: "" },
                      model: {
                        value: _vm.liveinfo.isScheduleUse,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveinfo, "isScheduleUse", $$v)
                        },
                        expression: "liveinfo.isScheduleUse",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.liveinfo.isScheduleUse ? "사용" : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "validation-observer",
            { ref: "liveinfoIsScheduleRules" },
            [
              _vm.liveinfo.isScheduleUse
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림기간(Fr)",
                                "label-for": "liveinfo-spu-start-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림기간(Fr)",
                                  rules: {
                                    required: true,
                                    before: _vm.liveinfo.spuEndDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-spu-start-date",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.spuStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "spuStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.spuStartDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "스케줄 팝업 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4126294070
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.liveinfo.isSpuOneTime
                        ? _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "알림기간(To)",
                                    "label-for": "liveinfo-spu-end-date",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "알림기간(To)",
                                      rules: {
                                        required: true,
                                        after: _vm.liveinfo.spuStartDate,
                                        dateBetween: [
                                          _vm.liveinfo.startDate,
                                          _vm.liveinfo.endDate,
                                        ],
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            var failedRules = ref.failedRules
                                            return [
                                              _c("b-form-datepicker", {
                                                attrs: {
                                                  id: "liveinfo-spu-end-date",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.liveinfo.spuEndDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.liveinfo,
                                                      "spuEndDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "liveinfo.spuEndDate",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        failedRules.hasOwnProperty(
                                                          "dateBetween"
                                                        )
                                                          ? "스케줄 팝업 기간은 게시기간 이내로 제한됩니다."
                                                          : errors[0]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      201237686
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("b-col", { attrs: { cols: "12", md: "6" } }),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림 유지시간",
                                "label-for": "liveinfo-spu-delay-sec",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림 유지시간",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("v-select", {
                                            staticStyle: { width: "210px" },
                                            attrs: {
                                              id: "liveinfo-spu-delay-sec",
                                              options:
                                                _vm.constCodes.selectTimes,
                                              reduce: function (option) {
                                                return option.code
                                              },
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.spuDelaySec,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "spuDelaySec",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.spuDelaySec",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2625410429
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("label", [_vm._v("알림 시간 선택")]),
                      ]),
                      _vm._l(_vm.liveinfo.schedules, function (sched, idx) {
                        return _c(
                          "b-col",
                          {
                            key: sched.id,
                            staticClass:
                              "d-flex align-items-center justify-content-start",
                            class: { "mt-25": idx !== 0 },
                            attrs: { id: "schedules" + sched.id, cols: "12" },
                          },
                          [
                            sched.popUpType === 2
                              ? [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "알림 시간 선택",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-date-picker", {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  type: "time",
                                                  format: "HH:mm",
                                                  "value-type": "format",
                                                  placeholder: "HH:mm",
                                                  "time-picker-options": {
                                                    start: "08:00",
                                                    step: "00:05",
                                                    end: "20:00",
                                                  },
                                                },
                                                model: {
                                                  value: sched.noticeTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      sched,
                                                      "noticeTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "sched.noticeTime",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  idx !== _vm.getSchedIdxFirstOrLast(2, true)
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            variant: "outline-danger",
                                            size: "sm",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.liveinfo.schedules.splice(
                                                idx,
                                                1
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-25",
                                            attrs: { icon: "XIcon" },
                                          }),
                                          _c("span", [_vm._v("삭제")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  idx === _vm.getSchedIdxFirstOrLast(2, false)
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "outline-primary",
                                            size: "sm",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.liveinfo.schedules.push(
                                                {
                                                  noticeTime: null,
                                                  popUpType: 2,
                                                }
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-25",
                                            attrs: { icon: "PlusIcon" },
                                          }),
                                          _c("span", [_vm._v("추가")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label:
                                  "알림창 내용 (※ 처방팝업과 스케줄팝업 문구는 반드시 다르게 설정하여 주세요.)",
                                "label-for": "liveinfo-spu-content",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림창 내용",
                                  rules: "required|popupContent",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("tinymce-editor", {
                                            attrs: { "is-table": true },
                                            model: {
                                              value: _vm.liveinfo.spuContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "spuContent",
                                                  $$v
                                                )
                                              },
                                              expression: "liveinfo.spuContent",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1013017084
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-start",
                  attrs: { cols: "12", md: "6" },
                },
                [
                  _c("feather-icon", {
                    attrs: { icon: "CoffeeIcon", size: "19" },
                  }),
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0 ml-50",
                      staticStyle: { "min-width": "150px" },
                    },
                    [_vm._v(" 진료 후 팝업 ")]
                  ),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "custom-control-info",
                      staticStyle: { "min-width": "120px" },
                      attrs: { switch: "", inline: "" },
                      model: {
                        value: _vm.liveinfo.isAfterConsultPopup,
                        callback: function ($$v) {
                          _vm.$set(_vm.liveinfo, "isAfterConsultPopup", $$v)
                        },
                        expression: "liveinfo.isAfterConsultPopup",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.liveinfo.isAfterConsultPopup
                              ? "사용"
                              : "사용안함"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.liveinfo.isAfterConsultPopup
            ? _c(
                "b-row",
                { staticClass: "mt-1" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        " tip. 대기환자 0명 감지 후 10초 시점에 노출되는 팝업, 동시 최대 2개 노출(자동 균등), 컨텐츠에 설정된 타겟 사용, 팝업기간에 한 번만 노출 "
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "validation-observer",
            { ref: "liveinfoIsAcpRules" },
            [
              _vm.liveinfo.isAfterConsultPopup
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림기간(Fr)",
                                "label-for": "liveinfo-acp-start-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림기간(Fr)",
                                  rules: {
                                    required: true,
                                    before: _vm.liveinfo.acpEndDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-acp-start-date",
                                              placeholder: "알림기간(Fr)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.acpStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "acpStartDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.acpStartDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "진료 후 팝업 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3702811902
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림기간(To)",
                                "label-for": "liveinfo-acp-end-date",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림기간(To)",
                                  rules: {
                                    required: true,
                                    after: _vm.liveinfo.acpStartDate,
                                    dateBetween: [
                                      _vm.liveinfo.startDate,
                                      _vm.liveinfo.endDate,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "liveinfo-acp-end-date",
                                              placeholder: "알림기간(To)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.acpEndDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "acpEndDate",
                                                  $$v
                                                )
                                              },
                                              expression: "liveinfo.acpEndDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "dateBetween"
                                                    )
                                                      ? "진료 후 팝업 기간은 게시기간 이내로 제한됩니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3824003505
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "w-100" }),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림 시점",
                                "label-for": "liveinfo-acp-time-range",
                              },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "liveinfo-acp-time-range",
                                  options: _vm.constCodes.acpTimeRanges,
                                  reduce: function (option) {
                                    return option.code
                                  },
                                  clearable: false,
                                },
                                on: { input: _vm.onAcpTimeRangeChange },
                                model: {
                                  value: _vm.acpTimeRangeSelected,
                                  callback: function ($$v) {
                                    _vm.acpTimeRangeSelected = $$v
                                  },
                                  expression: "acpTimeRangeSelected",
                                },
                              }),
                              _vm.acpTimeRangeSelected === 99
                                ? _c(
                                    "b-row",
                                    { staticClass: "mt-1" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: "시작 시각",
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for: "liveinfo-acp-start-hour",
                                                          },
                                                        },
                                                        [_vm._v("시작 시각")]
                                                      ),
                                                      _c("v-select", {
                                                        attrs: {
                                                          id: "liveinfo-acp-start-hour",
                                                          options:
                                                            _vm.constCodes
                                                              .acpHours,
                                                          reduce: function (
                                                            option
                                                          ) {
                                                            return option.code
                                                          },
                                                          selectable: function (
                                                            option
                                                          ) {
                                                            return (
                                                              !_vm.liveinfo
                                                                .acpEndHour ||
                                                              option.code <=
                                                                _vm.liveinfo
                                                                  .acpEndHour
                                                            )
                                                          },
                                                          clearable: false,
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.liveinfo
                                                              .acpStartHour,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.liveinfo,
                                                              "acpStartHour",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "liveinfo.acpStartHour",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3225154770
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: "종료 시각",
                                              rules: {
                                                required: true,
                                                acpEndHourAfter:
                                                  _vm.liveinfo.acpStartHour,
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    var failedRules =
                                                      ref.failedRules
                                                    return [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for: "liveinfo-acp-end-hour",
                                                          },
                                                        },
                                                        [_vm._v("종료 시각")]
                                                      ),
                                                      _c("v-select", {
                                                        attrs: {
                                                          id: "liveinfo-acp-end-hour",
                                                          options:
                                                            _vm.constCodes
                                                              .acpHours,
                                                          reduce: function (
                                                            option
                                                          ) {
                                                            return option.code
                                                          },
                                                          selectable: function (
                                                            option
                                                          ) {
                                                            return (
                                                              !_vm.liveinfo
                                                                .acpStartHour ||
                                                              option.code >=
                                                                _vm.liveinfo
                                                                  .acpStartHour
                                                            )
                                                          },
                                                          clearable: false,
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.liveinfo
                                                              .acpEndHour,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.liveinfo,
                                                              "acpEndHour",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "liveinfo.acpEndHour",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                failedRules.hasOwnProperty(
                                                                  "acpEndHourAfter"
                                                                )
                                                                  ? "종료 시각은 시작 시각 이상이어야 합니다."
                                                                  : errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              350611913
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림 유지시간",
                                "label-for": "liveinfo-acp-delay-sec",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림 유지시간",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("v-select", {
                                            attrs: {
                                              id: "liveinfo-acp-delay-sec",
                                              options:
                                                _vm.constCodes.selectTimes,
                                              reduce: function (option) {
                                                return option.code
                                              },
                                              clearable: false,
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.acpDelaySec,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "acpDelaySec",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.acpDelaySec",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3083224797
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "팝업기간 내 최대 노출 수",
                                "label-for": "liveinfo-acp-pop-count-period",
                              },
                            },
                            [
                              _c("b-form-spinbutton", {
                                attrs: {
                                  id: "liveinfo-acp-pop-count-period",
                                  min: "1",
                                  max: "100",
                                  inline: "",
                                },
                                model: {
                                  value: _vm.liveinfo.acpPopCount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.liveinfo, "acpPopCount", $$v)
                                  },
                                  expression: "liveinfo.acpPopCount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "노출 순서" } },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  " 전날 노출이 상대적으로 적었던 팝업을 자동으로 우선 노출합니다. 별도 가중치 설정 없이 시스템이 균등 노출을 보정합니다. "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림창 내용",
                                "label-for": "liveinfo-acp-content",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림창 내용",
                                  rules: "required|popupContent",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("tinymce-editor", {
                                            attrs: { "is-table": true },
                                            model: {
                                              value: _vm.liveinfo.acpContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "acpContent",
                                                  $$v
                                                )
                                              },
                                              expression: "liveinfo.acpContent",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2361651032
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "7" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림창 버튼 텍스트",
                                "label-for": "liveinfo-acp-button-text",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림창 버튼 텍스트",
                                  rules: "required|max:20",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "liveinfo-acp-button-text",
                                              maxlength: "20",
                                              placeholder: "상세정보 보기",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.liveinfo.acpButtonText,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveinfo,
                                                  "acpButtonText",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveinfo.acpButtonText",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "text-muted" },
                                            [_vm._v("최대 20자")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3569022194
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림창 컬러",
                                "label-for": "liveinfo-acp-color-type",
                              },
                            },
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "liveinfo-acp-color-type",
                                  options: _vm.constCodes.acpColorTypes,
                                  "value-field": "code",
                                  "text-field": "label",
                                },
                                model: {
                                  value: _vm.liveinfo.acpColorType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.liveinfo, "acpColorType", $$v)
                                  },
                                  expression: "liveinfo.acpColorType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "mt-1", attrs: { cols: "12", md: "5" } },
                        [
                          _c("label", [_vm._v("알림창 미리보기")]),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              " 색상 설정 등을 확인하기 위한 참고용 프리뷰로, 실제 팝업과 다를 수 있습니다."
                            ),
                          ]),
                          _c("div", { staticClass: "acp-preview-wrap" }, [
                            _c("div", { staticClass: "acp-preview" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "acp-preview__header",
                                  class:
                                    "acp-preview__header--" +
                                    (_vm.liveinfo.acpColorType === 2
                                      ? "blue"
                                      : "gray"),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "acp-preview__title" },
                                    [_vm._v("닥터인포 알림")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "acp-preview__close" },
                                    [_vm._v("×")]
                                  ),
                                ]
                              ),
                              _c("iframe", {
                                staticClass: "acp-preview__body",
                                attrs: {
                                  srcdoc: _vm.acpPreviewHtml,
                                  sandbox: "",
                                  frameborder: "0",
                                  scrolling: "no",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "acp-preview__bottom" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.liveinfo.acpButtonText ||
                                          "상세정보 보기"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.contentType === 1
        ? _c(
            "b-card",
            [
              _c(
                "b-row",
                { staticClass: "align-items-center" },
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "UsersIcon", size: "19" },
                      }),
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "150px" },
                        },
                        [_vm._v(" 환자 타입 조회 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          staticStyle: { "min-width": "120px" },
                          attrs: { switch: "", inline: "" },
                          on: { change: _vm.changePatientType },
                          model: {
                            value: _vm.liveinfo.isPatientType,
                            callback: function ($$v) {
                              _vm.$set(_vm.liveinfo, "isPatientType", $$v)
                            },
                            expression: "liveinfo.isPatientType",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.liveinfo.isPatientType ? "사용" : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.liveinfo.isPatientType
                ? [
                    _c(
                      "b-row",
                      { staticClass: "mt-1" },
                      [
                        _c("b-col", [
                          _c("small", { staticClass: "text-primary" }, [
                            _c("strong", [
                              _vm._v(
                                "① 실행 대상: 상단 '약품정보 노출 조건'에서 설정한 진료과 및 지역의 요양기관"
                              ),
                            ]),
                            _vm._v(
                              " (※ 의사 단위로 적용되는 '타겟그룹'과 함께 사용 불가) "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-25" },
                      [
                        _c("b-col", [
                          _c("small", [
                            _vm._v(" (진료과: "),
                            _c("strong", { staticClass: "text-primary" }, [
                              _vm._v(
                                _vm._s(_vm.liveinfo.condDeptNames || "미지정")
                              ),
                            ]),
                            _vm._v(" , 지역: "),
                            _c("strong", { staticClass: "text-primary" }, [
                              _vm._v(
                                _vm._s(_vm.liveinfo.condRegionNames || "미지정")
                              ),
                            ]),
                            _vm._v(") "),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c("hr", { staticClass: "my-1" }),
                    _c("h5", { staticClass: "mb-50" }, [
                      _vm._v(" 회차별 기간 설정 "),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mb-1" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addPatientTypePeriod($event)
                              },
                            },
                          },
                          [_vm._v(" 회차 추가 ")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "ml-1",
                            attrs: { variant: "outline-danger" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.removePatientTypePeriod()
                              },
                            },
                          },
                          [_vm._v(" 전체 초기화 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "validation-observer",
                      { ref: "ptPeriodRules" },
                      [
                        _vm._l(
                          (_vm.liveinfo.patientType &&
                            _vm.liveinfo.patientType.periods) ||
                            [],
                          function (period, rIdx) {
                            return _c(
                              "div",
                              {
                                key: "period-" + rIdx,
                                staticClass: "border rounded p-1 mb-1",
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "align-items-center mb-1" },
                                  [
                                    _c("b-col", [
                                      _c(
                                        "h6",
                                        {
                                          staticClass: "mb-0 font-weight-bold",
                                        },
                                        [_vm._v(_vm._s(rIdx + 1) + "회차")]
                                      ),
                                    ]),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "auto" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.isRoundDeleteDisabled(rIdx),
                                              variant: "flat-danger",
                                              size: "sm",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.removePatientTypePeriod(
                                                  rIdx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: {
                                                icon: "Trash2Icon",
                                                size: "14",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "border-right pr-2",
                                        attrs: { cols: "12", md: "4" },
                                      },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " 과거 진료내역 조회 기간 "
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted ml-25",
                                                        },
                                                        [_vm._v("최대 60개월")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-start",
                                              },
                                              [
                                                _c("validation-provider", {
                                                  staticStyle: {
                                                    flex: "1 1 0%",
                                                    "min-width": "0",
                                                  },
                                                  attrs: {
                                                    name:
                                                      rIdx +
                                                      1 +
                                                      "회차 데이터조회 시작일",
                                                    rules: {
                                                      required: true,
                                                      dateBefore:
                                                        period.dataEndDate,
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          var failedRules =
                                                            ref.failedRules
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "시작일",
                                                                  disabled:
                                                                    _vm.isPatientTypePeriodDisabled(
                                                                      rIdx,
                                                                      "data"
                                                                    ),
                                                                  state:
                                                                    errors.length >
                                                                    0
                                                                      ? false
                                                                      : null,
                                                                },
                                                                model: {
                                                                  value:
                                                                    period.dataStartDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        period,
                                                                        "dataStartDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "period.dataStartDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      failedRules.required
                                                                        ? "[시작일(Fr)]는(은) 필수 입력입니다."
                                                                        : failedRules.dateBefore
                                                                        ? "[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다."
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "mx-50 pt-50",
                                                  },
                                                  [_vm._v("~")]
                                                ),
                                                _c("validation-provider", {
                                                  staticStyle: {
                                                    flex: "1 1 0%",
                                                    "min-width": "0",
                                                  },
                                                  attrs: {
                                                    name:
                                                      rIdx +
                                                      1 +
                                                      "회차 데이터조회 종료일",
                                                    rules: {
                                                      required: true,
                                                      dateAfter:
                                                        period.dataStartDate,
                                                      dateWithinMonths: {
                                                        startDate:
                                                          period.dataStartDate,
                                                        months: 60,
                                                      },
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          var failedRules =
                                                            ref.failedRules
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "종료일",
                                                                  disabled:
                                                                    _vm.isPatientTypePeriodDisabled(
                                                                      rIdx,
                                                                      "data"
                                                                    ),
                                                                  state:
                                                                    errors.length >
                                                                    0
                                                                      ? false
                                                                      : null,
                                                                },
                                                                model: {
                                                                  value:
                                                                    period.dataEndDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        period,
                                                                        "dataEndDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "period.dataEndDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      failedRules.required
                                                                        ? "[종료일(To)]는(은) 필수 입력입니다."
                                                                        : failedRules.dateAfter
                                                                        ? "[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다."
                                                                        : failedRules.dateWithinMonths
                                                                        ? "최대 60개월까지 설정 가능합니다."
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12", md: "4" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " 사전 스크리닝 기간 "
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-secondary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (게시기간 : "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-primary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              "" +
                                                                (!_vm.liveinfo
                                                                  .startDate
                                                                  ? "미지정"
                                                                  : _vm.liveinfo
                                                                      .startDate)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-secondary",
                                                        },
                                                        [_vm._v("~")]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-primary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              " " +
                                                                (!_vm.liveinfo
                                                                  .endDate
                                                                  ? "미지정"
                                                                  : _vm.liveinfo
                                                                      .endDate)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-secondary",
                                                        },
                                                        [_vm._v(") ")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-start",
                                              },
                                              [
                                                _c("validation-provider", {
                                                  staticStyle: {
                                                    flex: "1 1 0%",
                                                    "min-width": "0",
                                                  },
                                                  attrs: {
                                                    name:
                                                      rIdx +
                                                      1 +
                                                      "회차 사전스크리닝 시작일",
                                                    rules: {
                                                      required: true,
                                                      dateBetween: [
                                                        _vm.liveinfo.startDate,
                                                        _vm.liveinfo.endDate,
                                                      ],
                                                      dateBefore:
                                                        period.screeningEndDate,
                                                      dateOverlapStart: [
                                                        rIdx,
                                                        _vm.patientTypeScreeningPeriodSet,
                                                      ],
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          var failedRules =
                                                            ref.failedRules
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "시작일",
                                                                  min: _vm.tomorrow,
                                                                  disabled:
                                                                    _vm.isPatientTypePeriodDisabled(
                                                                      rIdx,
                                                                      "screening-start"
                                                                    ),
                                                                  state:
                                                                    errors.length >
                                                                    0
                                                                      ? false
                                                                      : null,
                                                                },
                                                                model: {
                                                                  value:
                                                                    period.screeningStartDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        period,
                                                                        "screeningStartDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "period.screeningStartDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      failedRules.required
                                                                        ? "[시작일(Fr)]는(은) 필수 입력입니다."
                                                                        : failedRules.dateBetween
                                                                        ? "게시 기간 내로 설정해 주세요."
                                                                        : failedRules.dateBefore
                                                                        ? "[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다."
                                                                        : failedRules.dateOverlapStart
                                                                        ? "다른 회차의 사전 스크리닝 기간과 겹치지 않게 입력해 주세요."
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "mx-50 pt-50",
                                                  },
                                                  [_vm._v("~")]
                                                ),
                                                _c("validation-provider", {
                                                  staticStyle: {
                                                    flex: "1 1 0%",
                                                    "min-width": "0",
                                                  },
                                                  attrs: {
                                                    name:
                                                      rIdx +
                                                      1 +
                                                      "회차 사전스크리닝 종료일",
                                                    rules: {
                                                      required: true,
                                                      dateBetween: [
                                                        _vm.liveinfo.startDate,
                                                        _vm.liveinfo.endDate,
                                                      ],
                                                      dateAfter:
                                                        period.screeningStartDate,
                                                      dateLess:
                                                        period.popupStartDate,
                                                      dateOverlapEnd: [
                                                        rIdx,
                                                        _vm.patientTypeScreeningPeriodSet,
                                                      ],
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          var failedRules =
                                                            ref.failedRules
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "종료일",
                                                                  min: _vm.today,
                                                                  disabled:
                                                                    _vm.isPatientTypePeriodDisabled(
                                                                      rIdx,
                                                                      "screening-end"
                                                                    ),
                                                                  state:
                                                                    errors.length >
                                                                    0
                                                                      ? false
                                                                      : null,
                                                                },
                                                                model: {
                                                                  value:
                                                                    period.screeningEndDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        period,
                                                                        "screeningEndDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "period.screeningEndDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      failedRules.required
                                                                        ? "[종료일(To)]는(은) 필수 입력입니다."
                                                                        : failedRules.dateBetween
                                                                        ? "게시 기간 내로 설정해 주세요."
                                                                        : failedRules.dateAfter
                                                                        ? "[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다."
                                                                        : failedRules.dateLess
                                                                        ? "같은 회차의 팝업 노출 기간과 겹치지 않게 입력해 주세요."
                                                                        : failedRules.dateOverlapEnd
                                                                        ? "다른 회차의 사전 스크리닝 기간과 겹치지 않게 입력해 주세요."
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12", md: "4" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " 팝업 노출 기간 "
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-secondary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (게시기간 : "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-primary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              "" +
                                                                (!_vm.liveinfo
                                                                  .startDate
                                                                  ? "미지정"
                                                                  : _vm.liveinfo
                                                                      .startDate)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-secondary",
                                                        },
                                                        [_vm._v("~")]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "ml-50 text-primary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              " " +
                                                                (!_vm.liveinfo
                                                                  .endDate
                                                                  ? "미지정"
                                                                  : _vm.liveinfo
                                                                      .endDate)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-secondary",
                                                        },
                                                        [_vm._v(") ")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-start",
                                              },
                                              [
                                                _c("validation-provider", {
                                                  staticStyle: {
                                                    flex: "1 1 0%",
                                                    "min-width": "0",
                                                  },
                                                  attrs: {
                                                    name:
                                                      rIdx +
                                                      1 +
                                                      "회차 팝업노출 시작일",
                                                    rules: {
                                                      required: true,
                                                      dateBetween: [
                                                        _vm.liveinfo.startDate,
                                                        _vm.liveinfo.endDate,
                                                      ],
                                                      dateMore:
                                                        period.screeningEndDate,
                                                      dateBefore:
                                                        period.popupEndDate,
                                                      dateOverlapStart: [
                                                        rIdx,
                                                        _vm.patientTypePopupPeriodSet,
                                                      ],
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          var failedRules =
                                                            ref.failedRules
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "시작일",
                                                                  min: _vm.tomorrow,
                                                                  disabled:
                                                                    _vm.isPatientTypePeriodDisabled(
                                                                      rIdx,
                                                                      "popup-start"
                                                                    ),
                                                                  state:
                                                                    errors.length >
                                                                    0
                                                                      ? false
                                                                      : null,
                                                                },
                                                                model: {
                                                                  value:
                                                                    period.popupStartDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        period,
                                                                        "popupStartDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "period.popupStartDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      failedRules.required
                                                                        ? "[시작일(Fr)]는(은) 필수 입력입니다."
                                                                        : failedRules.dateBetween
                                                                        ? "게시 기간 내로 설정해 주세요."
                                                                        : failedRules.dateMore
                                                                        ? "같은 회차의 사전 스크리닝 기간과 겹치지 않게 입력해 주세요."
                                                                        : failedRules.dateBefore
                                                                        ? "[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다."
                                                                        : failedRules.dateOverlapStart
                                                                        ? "다른 회차의 팝업 노출 기간과 겹치지 않게 입력해 주세요."
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "mx-50 pt-50",
                                                  },
                                                  [_vm._v("~")]
                                                ),
                                                _c("validation-provider", {
                                                  staticStyle: {
                                                    flex: "1 1 0%",
                                                    "min-width": "0",
                                                  },
                                                  attrs: {
                                                    name:
                                                      rIdx +
                                                      1 +
                                                      "회차 팝업노출 종료일",
                                                    rules: {
                                                      required: true,
                                                      dateBetween: [
                                                        _vm.liveinfo.startDate,
                                                        _vm.liveinfo.endDate,
                                                      ],
                                                      dateAfter:
                                                        period.popupStartDate,
                                                      dateOverlapEnd: [
                                                        rIdx,
                                                        _vm.patientTypePopupPeriodSet,
                                                      ],
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          var failedRules =
                                                            ref.failedRules
                                                          return [
                                                            _c(
                                                              "b-form-datepicker",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    "종료일",
                                                                  min: _vm.today,
                                                                  disabled:
                                                                    _vm.isPatientTypePeriodDisabled(
                                                                      rIdx,
                                                                      "popup-end"
                                                                    ),
                                                                  state:
                                                                    errors.length >
                                                                    0
                                                                      ? false
                                                                      : null,
                                                                },
                                                                model: {
                                                                  value:
                                                                    period.popupEndDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        period,
                                                                        "popupEndDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "period.popupEndDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      failedRules.required
                                                                        ? "[종료일(To)]는(은) 필수 입력입니다."
                                                                        : failedRules.dateBetween
                                                                        ? "게시 기간 내로 설정해 주세요."
                                                                        : failedRules.dateAfter
                                                                        ? "[시작일(Fr)]은 [종료일(To)]보다 늦을 수 없습니다."
                                                                        : failedRules.dateOverlapEnd
                                                                        ? "다른 회차의 팝업 노출 기간과 겹치지 않게 입력해 주세요."
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _c("validation-provider", {
                          attrs: { name: "회차", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("input", {
                                      attrs: { type: "hidden" },
                                      domProps: {
                                        value:
                                          (_vm.liveinfo.patientType &&
                                            _vm.liveinfo.patientType.periods &&
                                            _vm.liveinfo.patientType.periods
                                              .length) ||
                                          "",
                                      },
                                    }),
                                    errors[0]
                                      ? _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "[회차]는(은) 필수 입력입니다."
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            181951810
                          ),
                        }),
                        _c("hr", { staticClass: "my-1" }),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center mb-50" },
                          [
                            _c("h5", { staticClass: "mb-0" }, [
                              _vm._v(" 환자 타입(조건) 및 알림 팝업 설정 "),
                            ]),
                            _c(
                              "b-badge",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.right.html",
                                    modifiers: {
                                      hover: true,
                                      right: true,
                                      html: true,
                                    },
                                  },
                                ],
                                staticStyle: {
                                  padding: "0px",
                                  "margin-left": "5px",
                                },
                                attrs: {
                                  variant: "light-secondary",
                                  title:
                                    "1회차 시작 후에는 타입을 추가/수정/삭제할 수 없습니다. 불가피하게 변경이 필요한 경우 회차 삭제를 통해 수집된 데이터를 전체 초기화하고 1회차부터 다시 진행해야 합니다.",
                                },
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "InfoIcon" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mb-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-primary",
                                  disabled: _vm.isPatientTypeStarted,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.patientTypeSelect.open()
                                  },
                                },
                              },
                              [_vm._v(" 타입 추가 ")]
                            ),
                          ],
                          1
                        ),
                        !_vm.liveinfo.patientType ||
                        !_vm.liveinfo.patientType.conds ||
                        !_vm.liveinfo.patientType.conds.length
                          ? _c(
                              "b-row",
                              { staticClass: "mt-1" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "text-secondary my-50" },
                                      [_vm._v(" 추가된 타입이 없습니다. ")]
                                    ),
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "타입",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("input", {
                                                  attrs: { type: "hidden" },
                                                  domProps: {
                                                    value:
                                                      (_vm.liveinfo
                                                        .patientType &&
                                                        _vm.liveinfo.patientType
                                                          .conds &&
                                                        _vm.liveinfo.patientType
                                                          .conds.length) ||
                                                      "",
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "[타입]는(은) 필수 입력입니다."
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1270765539
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(
                          (_vm.liveinfo.patientType &&
                            _vm.liveinfo.patientType.conds) ||
                            [],
                          function (cond, idx) {
                            return _c(
                              "b-row",
                              {
                                key: idx,
                                staticClass:
                                  "mt-1 align-items-center border rounded p-1 mx-0",
                              },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "font-weight-bold text-primary",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(" Type" + _vm._s(idx + 1) + " ")]
                                ),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-bold mb-25" },
                                      [_vm._v(_vm._s(cond.title))]
                                    ),
                                    _vm._l(
                                      _vm.parsePatientTypeLabels(
                                        cond.conditionLabels
                                      ),
                                      function (label, labelIdx) {
                                        return _c(
                                          "span",
                                          {
                                            key: labelIdx,
                                            staticClass:
                                              "badge badge-light-primary mr-50 mb-25",
                                          },
                                          [_vm._v(_vm._s(label))]
                                        )
                                      }
                                    ),
                                    !cond.conditionLabels ||
                                    _vm.parsePatientTypeLabels(
                                      cond.conditionLabels
                                    ).length === 0
                                      ? _c(
                                          "span",
                                          { staticClass: "text-secondary" },
                                          [_vm._v("조건 없음")]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn-icon mr-25",
                                        attrs: {
                                          variant: "flat-secondary",
                                          size: "sm",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.patientTypeSelect.open(
                                              idx
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: {
                                            icon: "EditIcon",
                                            size: "16",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn-icon",
                                        attrs: {
                                          variant: "flat-danger",
                                          size: "sm",
                                          disabled: _vm.isPatientTypeStarted,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.removePatientTypeCond(
                                              idx
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: {
                                            icon: "Trash2Icon",
                                            size: "16",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c("region-select", {
        attrs: {
          "show-region-select": _vm.showRegionSelect,
          "selected-value": _vm.liveinfo.condRegionCodes,
        },
        on: { close: _vm.regionSelect.close },
      }),
      _c("medi-dept-select", {
        attrs: {
          "show-medi-dept-select": _vm.showMediDeptSelect,
          "selected-value": _vm.liveinfo.condDeptCodes,
        },
        on: { close: _vm.mediDeptSelect.close },
      }),
      _c("target-group-select", {
        attrs: { "show-target-group-select": _vm.showTargetGroupSelect },
        on: { close: _vm.targetGroupSelect.close },
      }),
      _c("main-top-fix-manage", {
        attrs: { "show-main-top-fix-manage": _vm.showMainTopFixManage },
        on: { close: _vm.mainTopFixManage.close },
      }),
      _c("interest-content-select", {
        attrs: {
          "show-content-select": _vm.showInterestContentSelect,
          "selected-value": _vm.liveinfo.interestContentIds,
        },
        on: { close: _vm.interestContentSelect.close },
      }),
      _vm.contentType === 1
        ? _c("patient-type-select", {
            attrs: {
              "show-patient-type-select": _vm.showPatientTypeSelect,
              "selected-value": _vm.patientTypeSelectCond,
              "is-cond-readonly": _vm.isPatientTypeStarted,
            },
            on: { close: _vm.patientTypeSelect.close },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }